import React, { useEffect, useState } from "react";
import { Modal, Input, Button, Tag, Spin, message } from "antd";
import { formatAmount } from "../../config/helpers.js";
import usePayments from "../../hooks/usePayments.js";
import { Alert } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

export default function CompanyPaymentModal({ open, onClose, companies, onPaymentSaved }) {
  const [search, setSearch] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("");
  const { recordPayment, loading, error, success } = usePayments();

  const handleSavePayment = async () => {
    if (!paymentAmount || isNaN(paymentAmount)) {
      Modal.error({
        title: "Errueur de paiement",
        content: "Vous devez entrer une somme valide",
        okText: "Ok, j'ai compris !"
      });
      return;
    }

    if (paymentAmount > selectedCompany.remaining) {
      Modal.error({
        title: "Errueur de paiement",
        content: "La somme que vous rentrez est supérieure à celle que cette entreprise doit verser",
        okText: "Ok, j'ai compris !"
      });
      return;
    }

    if (paymentAmount <= 0) {
      Modal.error({
        title: "Errueur de paiement",
        content: "La somme que vous rentrez doit être est supérieure à 0",
        okText: "Ok, j'ai compris !"
      });
      return;
    }

    const success = await recordPayment({ type: 'company', id: selectedCompany.id, amount: paymentAmount, method: "cash" });

    if (success) {
      message.success("Paiement enregistré avec succès !");
      if (onPaymentSaved) {
        onPaymentSaved(selectedCompany.id, Number(paymentAmount));
      }
      setPaymentAmount("");
      setSelectedCompany(null);
    }
  };

  const filteredCompanies = companies.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      title="Enregistrer un paiement"
      bodyStyle={{ maxHeight: 600, overflowY: "auto", padding: "16px" }}
    >
      <Input
        placeholder="Search company..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginBottom: 16, height: 40, borderRadius: 8 }}
      />
      {loading ? (
        <div
          style={{
            marginTop: "10rem",
            display: "flex",
            width: "100%",
            justifyContent: "center",
            height: "10rem",
          }}
        >
          <Spin size="large" />
        </div>
      ): (
        <div className="company-list">
          {filteredCompanies.map((company) => {
            const isSelected = company.id === selectedCompany?.id;
            return (
              <div key={company.id} className="company-card">
                <div className="company-header">
                  <h4>{company.name}</h4>
                  <div className="tags">
                    {company.remaining > 0 && <>
                      <Tag color="red">Dette: {formatAmount(company.remaining)}</Tag>
                      {/*<Tag color="blue">{company.unpaidTickets} tickets</Tag>*/}
                    </>}
                    {company.lastPayment && (
                      <Tag color="green">
                        Dernier paiement: {formatAmount(company.lastPayment.amount)}, le {company.lastPayment?.date?.toDate()?.toLocaleDateString("fr-FR")}
                      </Tag>
                    )}
                  </div>
                </div>

                {company.remaining > 0 ? (
                  <div className="company-actions">
                    <Button type="primary" onClick={() => setSelectedCompany(isSelected ? null : company)}>
                      {isSelected ? "Annuler" : "Enregistrer un nouveau paiement"}
                    </Button>
                  </div>) : (
                    <Alert
                      message="L’entreprise n’a aucune dette envers vous"
                      type="success"
                      icon={<CheckCircleOutlined />}
                      showIcon
                      style={{ marginTop: 16, fontWeight: 500 }}
                    />
                  )}

                {isSelected && (
                  <div className="payment-section">
                    <Input
                      placeholder="Montant"
                      value={paymentAmount}
                      onChange={(e) => setPaymentAmount(e.target.value)}
                      style={{ width: 200, marginRight: 12 }}
                    />
                    <Button type="primary" onClick={() => handleSavePayment()}>
                      Enregistrer
                    </Button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      <style>{`
        .company-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .company-card {
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          background: #fff;
          padding: 16px;
          transition: box-shadow 0.2s ease;
        }

        .company-card:hover {
          box-shadow: 0 8px 24px rgba(0,0,0,0.08);
        }

        .company-header {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 12px;
        }

        .company-header h4 {
          margin: 0 0 8px 0;
        }

        .tags {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .company-actions {
          margin-bottom: 12px;
        }

        .payment-section {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 8px;
        }
      `}</style>
    </Modal>
  );
}
